import { render } from "./pathChoose.vue?vue&type=template&id=10170f4b&scoped=true"
import script from "./pathChoose.vue?vue&type=script&lang=js"
export * from "./pathChoose.vue?vue&type=script&lang=js"

import "./pathChoose.vue?vue&type=style&index=0&id=10170f4b&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10170f4b"]])

export default __exports__